import { css } from '@emotion/react'

export const RangeSliderStyles = css({
  '-webkit-appearance': 'none',
  '-webkit-tap-highlight-color': 'rgba(255, 255, 255, 0)',
  WebkitUserSelect: 'none',
  boxShadow: '0 0 0 #fff',
  width: '90%',
  margin: '20px 0 0 5%',
  padding: '0',
  '&:focus': {
    outline: 'none',
  },
  '&::-webkit-slider-runnable-track': {
    width: '100%',
    height: '8.4px',
    cursor: 'pointer',
    background: '#b0b8bf',
    borderRadius: '1.3px',
  },
  '&::-webkit-slider-thumb': {
    boxShadow: '1px 1px 1px #000000, 0px 0px 1px #0d0d0d',
    border: '4px solid #000000',
    height: '26px',
    width: '26px',
    borderRadius: '50%',
    background: '#ffffff',
    cursor: 'pointer',
    '-webkit-appearance': 'none',
    marginTop: '-8px',
  },
  '&:focus::-webkit-slider-runnable-track': {
    background: '#b0b8bf',
  },
  '&::-moz-range-track': {
    width: '100%',
    height: '8.4px',
    cursor: 'pointer',
    background: '#b0b8bf',
    borderRadius: '1.3px',
    border: '0.2px solid #010101',
  },
  '&::-moz-range-thumb': {
    boxShadow: '1px 1px 1px #000000, 0px 0px 1px #0d0d0d',
    border: '6px solid #000000',
    height: '30px',
    width: '30px',
    borderRadius: '50%',
    background: '#ffffff',
    cursor: 'pointer',
    '-webkit-appearance': 'none',
    marginTop: '-10px',
  },
  '&::-ms-track': {
    width: '100%',
    height: '8.4px',
    cursor: 'pointer',
    background: 'transparent',
    borderColor: 'transparent',
    borderWidth: '16px 0',
    color: 'transparent',
  },
  '&::-ms-fill-lower': {
    background: '#b0b8bf',
    border: '0.2px solid #010101',
    borderRadius: '2.6px',
    boxShadow: '1px 1px 1px #000000, 0px 0px 1px #0d0d0d',
  },
  '&::-ms-fill-upper': {
    background: '#b0b8bf',
    border: '0.2px solid #010101',
    borderRadius: '2.6px',
    boxShadow: '1px 1px 1px #000000, 0px 0px 1px #0d0d0d',
  },
  '&::-ms-thumb': {
    boxShadow: '1px 1px 1px #000000, 0px 0px 1px #0d0d0d',
    border: '1px solid #000000',
    height: '36px',
    width: '16px',
    borderRadius: '50%',
    background: '#ffffff',
    cursor: 'pointer',
  },
  '&:focus::-ms-fill-lower': {
    background: '#b0b8bf',
  },
  '&:focus::-ms-fill-upper': {
    background: '#b0b8bf',
  },
})

export const localizedInputs = css({
  'input::-webkit-outer-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0,
  },
  'input::-webkit-inner-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0,
  },
  "input[type='number']": {
    '-moz-appearance': 'textfield',
  },
})
